<style lang="scss">
.zoezi-site-selector {
    &.compact {
        margin: 0;
        flex-grow: 0;
        min-width: 0 !important;
        width: auto !important;
        display: inline-flex !important;
        align-content: center;

        > .col {
            padding: 0;
            flex-grow: 0;
            flex-basis: 0;
            max-width: 100%;

            > .multisite-selection {
                width: auto;
                max-width: 100%;
                font-size: 0.75em;
                line-height: 1.2;
                padding: 5px 10px !important;
                transition: all 250ms ease-in-out;
                transform: scale(0.96);

                &:hover {
                    transform: scale(1) translateY(-2px);
                }

                > .inside-sheet {
                    flex-wrap: wrap;

                    > .marker-row {
                        width: 100%;
                        min-width: 100px;
                        opacity: 0.7;
                    }

                    .v-icon {
                        font-size: 1em;
                    }

                    .z-clickable {
                        font-size: 1.25em;
                        white-space: nowrap;
                        max-width: 150px;
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        position: relative;
                        padding-right: 15px;

                        .v-icon {
                            position: absolute;
                            right: -2px;
                        }
                    }
                }
            }
        }
    }

    .multisite-selection {
        font-size: 1.25em;
    }
}
</style>

<template>
    <v-row
        v-if="hasMultiSites"
        @click="sitesMenuOpen = true"
        class="zoezi-site-selector"
        :class="{ compact: compact }"
    >
        <v-col cols="12">
            <v-sheet
                color="primary"
                rounded
                class="primarytext--text multisite-selection pa-2"
            >
                <div class="d-flex inside-sheet">
                    <div class="flex-grow-1 marker-row">
                        <v-icon color="primarytext"
                            >mdi-map-marker-star-outline</v-icon
                        ><span>{{ $translate("Choose location") }}</span>
                    </div>

                    <v-menu
                        v-model="sitesMenuOpen"
                        offset-y
                        :close-on-content-click="false"
                        content-class="primarytext"
                    >
                        <template v-slot:activator="{ on }">
                            <div v-on="on" class="z-clickable">
                                {{ $translate(selectedSite.name) }}
                                <v-icon color="primarytext"
                                    >mdi-chevron-down</v-icon
                                >
                            </div>
                        </template>

                        <v-text-field
                            :placeholder="$translate('Search')"
                            dense
                            v-model="filterSearchText"
                            clearable
                            class="mx-2"
                            autofocus
                            @keypress.enter.prevent="selectIfOne"
                            hide-details
                            @click:clear="filterSearchText = ''"
                        />

                        <v-list max-height="50vh" style="overflow-y: auto">
                            <v-list-item
                                class="z-clickable"
                                v-for="site in filteredSites"
                                :key="site.id"
                                @click="setSite(site)"
                                >{{ $translate(site.name) }}</v-list-item
                            >

                            <v-list-item v-if="filteredSites.length == 0">
                                {{ $translate("No location found") }}
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "zoezi-site-selector",

    zoezi: {
        title: "Site Selector",
        icon: "mdi-map-marker-star-outline",
    },

    props: {
        compact: {
            title: "Compact style. Two lines to save space",
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        sitesMenuOpen: false,
        filterSearchText: "",
    }),

    watch: {
        sitesMenuOpen(open) {
            if (open) {
                this.filterSearchText = "";
            }
        },
    },

    computed: {
        selectedSite() {
            return (
                this.sites.find(
                    (x) => x.id == this.$store.state.selectedSiteId
                ) || { id: 0, name: this.$translate("No location selected") }
            );
        },
        hasMultiSites() {
            return this.sites.length > 1;
        },
        sites() {
            if (!this.$store.state?.settings?.sites) {
                return [];
            }

            return this.$store.state.settings.sites
                .concat()
                .sort((a, b) =>
                    this.$translate(a.name).localeCompare(
                        this.$translate(b.name)
                    )
                );
        },
        filteredSites() {
            let s = this.filterSearchText?.toLowerCase();
            return this.sites.filter(
                (x) => !s || this.$translate(x.name).toLowerCase().includes(s)
            );
        },
    },

    methods: {
        setSite(site) {
            this.$store.dispatch("setSite", { siteId: site.id });
            this.sitesMenuOpen = false;
        },
        selectIfOne() {
            if (this.filteredSites.length == 1) {
                this.setSite(this.filteredSites[0]);
            }
        },
    },
};
</script>
